<template>
    <div class="fst-Header header" :class="{'showStructuredQuery' : showStructuredQuery}">
        <div class="header-left"
             :class="{'tour-show-step': (tourStep == '1')}">
            <div :class="['logo']">
                <el-tooltip effect="light" :content="$route.name === 'home' ? 'Reset search' : 'Back home'"
                            placement="top" :open-delay="808">
                    <svg xmlns="http://www.w3.org/2000/svg" width="201.27" height="41.026" viewBox="0 0 201.27 41.026"
                         class="pointer" @click="handleActionCommand('home')">
                        <g id="logo_white_1" transform="translate(-147.397 -955)">
                            <path id="Path_44092" data-name="logo-text"
                                  d="M6.107-13.593V-1.817A1.753,1.753,0,0,0,6.636-.529,1.778,1.778,0,0,0,7.924,0,1.739,1.739,0,0,0,9.2-.529a1.753,1.753,0,0,0,.529-1.288V-13.593h3.853a1.778,1.778,0,0,0,1.288-.529A1.739,1.739,0,0,0,15.4-15.4a1.739,1.739,0,0,0-.529-1.276,1.759,1.759,0,0,0-1.288-.541H2.266a1.734,1.734,0,0,0-1.288.541A1.739,1.739,0,0,0,.449-15.4a1.739,1.739,0,0,0,.529,1.277,1.753,1.753,0,0,0,1.288.529ZM32.522,0A1.778,1.778,0,0,0,33.81-.529a1.753,1.753,0,0,0,.529-1.288,1.739,1.739,0,0,0-.529-1.277,1.778,1.778,0,0,0-1.288-.529H23.012V-6.8h7.245a1.778,1.778,0,0,0,1.288-.529A1.739,1.739,0,0,0,32.074-8.6a1.753,1.753,0,0,0-.529-1.288,1.778,1.778,0,0,0-1.288-.529H23.012v-3.174h9.511a1.778,1.778,0,0,0,1.288-.529,1.739,1.739,0,0,0,.529-1.277,1.739,1.739,0,0,0-.529-1.276,1.759,1.759,0,0,0-1.288-.541H21.206a1.734,1.734,0,0,0-1.288.541,1.739,1.739,0,0,0-.529,1.276V-1.817a1.753,1.753,0,0,0,.529,1.288A1.753,1.753,0,0,0,21.206,0Zm8.97-8.6a4.8,4.8,0,0,1,1.461-3.519,4.8,4.8,0,0,1,3.519-1.461A4.834,4.834,0,0,1,50-12.121,4.8,4.8,0,0,1,51.462-8.6,4.8,4.8,0,0,1,50-5.083a4.834,4.834,0,0,1-3.531,1.46,4.8,4.8,0,0,1-3.519-1.46A4.8,4.8,0,0,1,41.492-8.6ZM53.268,2.266a1.768,1.768,0,0,0,1.23-.483A1.708,1.708,0,0,0,55.074.529a1.734,1.734,0,0,0-.472-1.3l-.035-.035-.046-.046q-.058-.069-.127-.138-.207-.184-.448-.368a8.989,8.989,0,0,0-1.587-.989,8.748,8.748,0,0,0,1.989-2.794A8.38,8.38,0,0,0,55.085-8.6a8.27,8.27,0,0,0-2.53-6.084,8.27,8.27,0,0,0-6.084-2.53,8.294,8.294,0,0,0-6.083,2.53A8.289,8.289,0,0,0,37.869-8.6a8.313,8.313,0,0,0,2.519,6.084A8.313,8.313,0,0,0,46.471,0,9.655,9.655,0,0,1,50.6.828a5.582,5.582,0,0,1,.989.575,2.209,2.209,0,0,1,.253.2.457.457,0,0,1,.069.058l.012.012.011.012A1.742,1.742,0,0,0,53.268,2.266Zm8.326-18.458a1.708,1.708,0,0,0-1.047-.909,1.76,1.76,0,0,0-1.391.092,1.714,1.714,0,0,0-.9,1.047,1.76,1.76,0,0,0,.092,1.391L65.147-1a1.739,1.739,0,0,0,.667.725A1.753,1.753,0,0,0,66.769,0h0a1.753,1.753,0,0,0,.955-.276A1.739,1.739,0,0,0,68.391-1l6.785-13.593a1.7,1.7,0,0,0,.1-1.38,1.756,1.756,0,0,0-.909-1.047,1.764,1.764,0,0,0-1.38-.1,1.756,1.756,0,0,0-1.047.909L66.769-5.865ZM81.179,0a1.739,1.739,0,0,0,1.276-.529,1.753,1.753,0,0,0,.529-1.288V-15.4a1.739,1.739,0,0,0-.529-1.276,1.721,1.721,0,0,0-1.276-.541,1.734,1.734,0,0,0-1.288.541,1.739,1.739,0,0,0-.529,1.276V-1.817a1.753,1.753,0,0,0,.529,1.288A1.753,1.753,0,0,0,81.179,0Zm8.073-3.623a1.753,1.753,0,0,0-1.288.529,1.739,1.739,0,0,0-.529,1.277,1.753,1.753,0,0,0,.529,1.288A1.753,1.753,0,0,0,89.252,0h7.924a5.017,5.017,0,0,0,3.68-1.53,5.017,5.017,0,0,0,1.529-3.68,5.017,5.017,0,0,0-1.529-3.68,5.017,5.017,0,0,0-3.68-1.53H92.644a1.519,1.519,0,0,1-1.115-.46,1.538,1.538,0,0,1-.472-1.127,1.5,1.5,0,0,1,.472-1.115,1.5,1.5,0,0,1,1.115-.472h7.924a1.778,1.778,0,0,0,1.288-.529,1.739,1.739,0,0,0,.529-1.277,1.739,1.739,0,0,0-.529-1.276,1.759,1.759,0,0,0-1.288-.541H92.644a5.017,5.017,0,0,0-3.68,1.53,5.017,5.017,0,0,0-1.53,3.68,4.992,4.992,0,0,0,1.53,3.68,5.017,5.017,0,0,0,3.68,1.53h4.531a1.5,1.5,0,0,1,1.115.471,1.5,1.5,0,0,1,.472,1.115,1.538,1.538,0,0,1-.472,1.127,1.519,1.519,0,0,1-1.115.46ZM119.956,0a1.778,1.778,0,0,0,1.288-.529,1.753,1.753,0,0,0,.529-1.288,1.739,1.739,0,0,0-.529-1.277,1.778,1.778,0,0,0-1.288-.529h-9.51V-6.8h7.245a1.778,1.778,0,0,0,1.288-.529,1.739,1.739,0,0,0,.529-1.276,1.753,1.753,0,0,0-.529-1.288,1.778,1.778,0,0,0-1.288-.529h-7.245v-3.174h9.51a1.778,1.778,0,0,0,1.288-.529,1.739,1.739,0,0,0,.529-1.277,1.739,1.739,0,0,0-.529-1.276,1.759,1.759,0,0,0-1.288-.541H108.641a1.734,1.734,0,0,0-1.288.541,1.739,1.739,0,0,0-.529,1.276V-1.817a1.753,1.753,0,0,0,.529,1.288A1.753,1.753,0,0,0,108.641,0ZM137.54-10.868a2.622,2.622,0,0,1-.8,1.92,2.616,2.616,0,0,1-1.921.793h-4.979v-5.439h4.979a2.6,2.6,0,0,1,1.921.8A2.6,2.6,0,0,1,137.54-10.868Zm-3.473,6.337,4,4A1.74,1.74,0,0,0,139.346,0a1.778,1.778,0,0,0,1.288-.529,1.753,1.753,0,0,0,.529-1.288,1.739,1.739,0,0,0-.529-1.277L138.207-5.52a6.278,6.278,0,0,0,2.139-2.254,6.161,6.161,0,0,0,.816-3.093,6.114,6.114,0,0,0-1.863-4.485,6.114,6.114,0,0,0-4.485-1.863h-6.785a1.734,1.734,0,0,0-1.288.541,1.739,1.739,0,0,0-.529,1.276V-1.817a1.753,1.753,0,0,0,.529,1.288A1.753,1.753,0,0,0,128.029,0a1.74,1.74,0,0,0,1.277-.529,1.753,1.753,0,0,0,.529-1.288V-4.531Z"
                                  transform="translate(207.504 984.512)" fill="currentColor"/>
                            <g id="Group_11" data-name="Group 11" transform="translate(147.397 955)">
                                <circle id="Ellipse_43" data-name="Ellipse 43" cx="8.805" cy="8.805" r="8.805"
                                        transform="translate(0 0)" fill="#4474f8"/>
                                <circle id="Ellipse_46" data-name="Ellipse 46" cx="8.805" cy="8.805" r="8.805"
                                        transform="translate(27.684 0)" fill="#f9b755"/>
                                <circle id="Ellipse_50" data-name="Ellipse 50" cx="8.791" cy="8.791" r="8.791"
                                        transform="translate(13.872 23.443)" fill="#f37a8a"/>
                                <path id="Intersection_1" data-name="Intersection 1"
                                      d="M.872,4.353C2.112,2.218,4.964.768,8.4,0A8.808,8.808,0,0,1,.9,13.247C-.2,9.808-.389,6.526.872,4.353Z"
                                      transform="translate(8.009 4.364)" fill="#b4c7fc"/>
                                <path id="Intersection_2" data-name="Intersection 2"
                                      d="M1.181,8.827A8.8,8.8,0,0,1,1.192,0C4.62.773,7.472,2.22,8.728,4.336c1.288,2.169,1.1,5.452-.013,8.894A8.8,8.8,0,0,1,1.181,8.827Z"
                                      transform="translate(27.682 4.381)" fill="#fce2bb"/>
                                <path id="Intersection_3" data-name="Intersection 3"
                                      d="M0,4.572a8.809,8.809,0,0,1,15.435-.021C13,7.231,10.248,9.051,7.724,9.066H7.692C5.168,9.066,2.422,7.251,0,4.572Z"
                                      transform="translate(14.924 23.481)" fill="#facad0"/>
                            </g>
                        </g>
                    </svg>
                </el-tooltip>
                <el-select v-model="appMode"
                           :class="['appMode', `locale-${locale}`]"
                           @change="handleAppMode"
                           :popper-class="['search', 'compare', 'smartSearch', 'iqAgent'].includes(appMode) ? 'z5m' : 'darkSelect z5m'">
                    <el-option value="search" :label="$t('label.searchMode')"></el-option>
                    <el-option value="smartSearch" :label="$t('label.smartSearchMode')"
                               v-show="allowed.contains('SMART_SEARCH')"></el-option>
                    <el-option value="compare" :label="$t('label.compare')"></el-option>
                    <el-option value="dashboard" :label="$t('label.analyticsMode')"
                               :title="!allowed.contains('ANALYTICS_DASHBOARD') ? $t('updragePlan') : ''"
                               v-show="allowed.contains('ANALYTICS_DASHBOARD')">
                        <i class="fas fa-lock mr-1" v-if="!allowed.contains('ANALYTICS_DASHBOARD')"></i>

                    </el-option>
                    <!--el-option value="clusterMap" v-if="isDeD7E1FCv || allowed.contains('CLUSTERING_REPORTS')" :label="$t('label.clusterMode')"></el-option-->
                    <el-option value="clusters" v-if="isDev || allowed.contains('CLUSTERING_REPORTS')"
                               :label="$t('label.clusterModeSrv')"></el-option>
                    <el-option value="iqAgent" v-if="allowed.contains('IQ_AGENT')"
                               :label="$t('label.iqAgentMode')"></el-option>
                </el-select>
            </div>

            <!--                <a href="/" class="logo" >-->
            <!--                    <img src="teq-logo-brand_1.svg" alt="Logo">-->
            <!--                </a>-->
            <div class="tour-step-note">
                <div class="title" v-html="tour.curStep.title"></div>
                <div class="text" v-html="tour.curStep.text"></div>
                <div class="control fixed">
                    <div class="wrap">
                        <el-button type="default" @click="handleNextStep('skip')">
                            {{ $t('quickTour.skip') }}
                        </el-button>
                        <div class="breadcrumbs" v-show="tour.steps.length > 1">
                            <div v-for="(crumb, ind) in tour.steps" :key="ind" @click="handleNextStep(ind)">
                                <i :class="['fa-circle', (tour.curStep.index === ind) ? 'fas' : 'far']"></i>
                            </div>
                        </div>
                        <div class="d-flex">
                            <el-button type="default" v-if="tour.curStep.index > 0" @click="handleNextStep('back')">
                                <svg xmlns="http://www.w3.org/2000/svg" width="17.818" height="12.526"
                                     viewBox="0 0 17.818 12.526">
                                    <path id="left-arrow"
                                          d="M5.812.188a.632.632,0,0,1,.9.889L2.158,5.63H17.18a.632.632,0,0,1,.638.629.64.64,0,0,1-.638.638H2.158L6.71,11.44a.645.645,0,0,1,0,.9.629.629,0,0,1-.9,0L.182,6.707a.633.633,0,0,1,0-.889Z"
                                          fill="currentColor"></path>
                                </svg>
                                {{ $t('quickTour.back') }}
                            </el-button>
                            <el-button type="primary" @click="handleNextStep()">
                                {{ $t('quickTour.next') }}
                                <svg xmlns="http://www.w3.org/2000/svg" width="17.818" height="12.526"
                                     viewBox="0 0 17.818 12.526">
                                    <path id="left-arrow"
                                          d="M5.812.188a.632.632,0,0,1,.9.889L2.158,5.63H17.18a.632.632,0,0,1,.638.629.64.64,0,0,1-.638.638H2.158L6.71,11.44a.645.645,0,0,1,0,.9.629.629,0,0,1-.9,0L.182,6.707a.633.633,0,0,1,0-.889Z"
                                          fill="currentColor"></path>
                                </svg>
                            </el-button>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="darkness"></div>
        <div class="header-center"
             :class="{'tour-show-step': (tourStep == '2')}">
            <slot name="prePredicate"></slot>
            <slot name="predicate"></slot>
        </div>
        <div class="darkness"></div>
        <div class="header-right">
            <div class="select-block">
                <el-select v-model="locale"
                           class="changeLocale"
                           @change="changeLocale"
                           :popper-class="appMode === 'dashboard' ? 'darkSelect' : ''">
                    <el-option value="en" label="Eng"></el-option>
                    <el-option value="ru" label="Рус"></el-option>
                </el-select>

                <div class="user">
                    <el-dropdown @command="handleActionCommand" trigger="click"
                                 class="userMenu">
                        <span class="el-dropdown-link">
                            <i class="fas fa-user mr-2"></i>
                          <span class="user-name">{{ userInfo.fullName || userInfo.username }}</span>
                            <i class="far fa-chevron-down"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown" :class="appMode === 'dashboard' ? 'darkSelect' : ''">
                            <el-dropdown-item v-for="a in actionsVisible" :key="a.id"
                                              :command="a.id"
                                              :title="a.locked ? 'Upgrade your plan' : ''"
                                              :disabled="a.disabled"
                            >
                                {{ a.title }}
                                <i class="fas fa-lock ml-1 mr-0" v-if="a.locked"></i>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>
            <div class="help-block">
                <template v-if="['Clusters','Dashboard','Search','smartSearch'].includes(from)">
                    <el-dropdown trigger="click" v-if="isRTFeature">
                        <el-button type="text el-dropdown-link" class="help-btn"><i
                                class="fas" :class="exportLoading ? 'fa-spinner fa-pulse' : 'fa-folder-download'"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown" :class="appMode === 'dashboard' ? 'darkSelect' : ''">
                            <el-dropdown-item>
                                <div @click="handleDataReport('trends')"
                                     v-html="$t('label.trendReport')"></div>
                            </el-dropdown-item>
                            <el-dropdown-item :disabled="exportLoading">
                                <div @click="handleExport()"
                                     v-html="$t('label.trendMonitoring')"></div>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>

                </template>
                <template v-else>
                    <el-tooltip effect="light" content="Back to Search" :open-delay="606">
                        <el-button type="text" class="help-btn" @click="handleActionCommand('home')">
                            <i class="fa-arrow-alt-right fas mr-1"></i>
                            <i class="fa-search fas"></i>
                        </el-button>
                    </el-tooltip>
                </template>
                <el-dropdown trigger="click">
                    <el-button type="text el-dropdown-link" class="help-btn"><i
                            class="fa-question-circle fas"></i></el-button>
                    <el-dropdown-menu slot="dropdown" :class="appMode === 'dashboard' ? 'darkSelect' : ''">
                        <el-dropdown-item disabled>
                            <b class="title">{{$t('label.help')}}</b>
                        </el-dropdown-item>
                        <el-dropdown-item>
                            <div @click="$emit('quickTour')" v-html="$t('label.quickTour')"></div>
                        </el-dropdown-item>
                        <el-dropdown-item>
                            <div @click="$emit('showHelp')" v-html="$t('label.help')"></div>
                        </el-dropdown-item>
                        <el-dropdown-item>
                            <div @click="handleShowDataCoverage" v-html="$t('label.dataCoverage')"></div>
                        </el-dropdown-item>

                        <template v-if="from !== 'Clusters'">
                            <el-dropdown-item disabled divided>
                                <b class="title">{{$t('label.leaveFeedback')}}</b>
                            </el-dropdown-item>
                            <el-dropdown-item>
                                <div @click="showUserFeedback('error')">{{$t('label.sendBug')}}</div>
                            </el-dropdown-item>
                            <el-dropdown-item>
                                <div @click="showUserFeedback('suggestion')">
                                    {{$t('label.suggestImprovement')}}
                                </div>
                            </el-dropdown-item>
                        </template>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <div class="darkness-uni"></div>
        <data-report :title="dataReport.title" ref="dataReport"
                     :type="dataReport.type" :params="dataReport.params"/>
        <feedback-form ref="feedbackForm"></feedback-form>
    </div>
</template>

<script>
    import _ from 'lodash';
    import {mapState} from "vuex";
    import i18n from '@/commons/i18n';
    import DataCoverage from "./search/DataCoverage";
    import DataReport from "./elements/DataReport";
    import FeedbackForm from "./search/actions/FeedbackForm";
    import axios from "axios";

    export default {
        name: "Header",
        components: {DataReport, FeedbackForm},
        props: {
            from: {
                type: String
            },
            defaultActiveTab: {
                type: String
            },
            mode: {
                type: String,
                default: 'search'
            },
            tourStep: {
                type: String
            },
            predicate: String,
            isNativeQuery: Boolean,
        },
        data() {
            return {
                dialogHelpVisible: false,
                queryFieldsControl: 'standard',
                appMode: 'search',
                locale: 'en',
                filterQuery: '',
                exportLoading: false,
                queryFieldsOpts: [
                    {label: 'Standard', value: 'standard'},
                    {label: 'Title only', value: 'title'},
                    {label: 'Title + Description', value: 'titleDescription'},
                    {label: 'Companies', value: 'companies'},
                ],
                tour: {
                    curStep: {
                        title: 'Ищите документы в модуле Поиска',
                        text: 'или перейдите в модуль <b>Кластеризации</b>',
                        index: 0
                    },
                    steps: [{
                        title: 'Ищите документы в модуле Поиска',
                        text: 'или перейдите в модуль <b>Кластеризации</b>',
                        actions: [{
                            type: 'highlight',
                            text: 'appMode'
                        }],
                    }],
                    highlight: {
                        appMode: false,
                    }
                },
                dataReport: {
                    title: null,
                    type: null,
                    params: {}
                }
            }
        },
        watch: {
            predicate(newVal) {
                this.filterQuery = newVal;
            }
        },
        computed: {
            ...mapState({
                userInfo: state => state.userInfo,
                notionsDict: state => state.notions,
                showStructuredQuery: state => state.showStructuredQuery
            }),
            actionsVisible() {
                return _.filter(this.actions, a => a && a.access);
            },
            allowed() {
                return this.$store.state.allowedActions;
            },
            isDev() {
                return this.userInfo.roles.indexOf('DEV') >= 0;
            },
            isRTFeature() {
                return this.userInfo.roles.includes('RT_FEATURE_USER');
            },
            actions() {
                return [
                    //     {
                    //     id: 'dashboard',
                    //     title: 'Dashboard',
                    //     access: true,
                    //     locked: !this.userInfo.roles.includes('ADMIN') && !this.allowed.contains('ANALYTICS_DASHBOARD')
                    // },
                    {
                        id: 'settings',
                        title: 'Notions',
                        access: true,
                        locked: !this.userInfo.roles.includes('ADMIN') && !this.allowed.contains('CREATE_NOTION')
                    }, {
                        id: 'searchProfile',
                        title: 'Search profile',
                        access: true,
                    }, {
                        id: 'admin',
                        title: 'Admin panel',
                        access: this.userInfo.roles.includes('ADMIN') || this.userInfo.roles.includes('DEV')
                    },
                    /*
                                        {
                                            id: 'langEn',
                                            title: 'Язык: En',
                                            access: i18n.locale === 'ru' && this.isDev
                                        }, {
                                            id: 'langRu',
                                            title: 'Lang: Ru',
                                            access: i18n.locale === 'en' && this.isDev
                                        },
                    */
                    {
                        id: 'logout',
                        title: 'Logout',
                        access: true
                    }].map(action => {
                    return _.merge(action, {
                        disabled: action.locked || this.$route.name === action.id,
                        title: this.$t('label.userMenu.' + action.id)
                    });
                });
            }
        },
        mounted() {
            // console.log('state:', this.$store.state, 'userInfo', this.userInfo.roles);
            this.appMode = this.mode;
            setTimeout(() => {
                this.locale = i18n.locale || 'en';
            }, 300)
        },
        methods: {
            handleAppMode(mode) {
                window.localStorage.setItem('wordStatQuery', JSON.stringify({
                    query: this.filterQuery,
                    docType: 'Science',
                    isNativeQuery: this.isNativeQuery,
                }));
                this.handleActionCommand(mode);
                // if (mode === 'dashboard') {
                //     this.handleActionCommand('dashboard');
                // } else if (mode === 'clusterMap') {
                //     this.handleActionCommand('clusterMap');
                // } else if (mode === 'clusters') {
                //     this.handleActionCommand('clusters');
                // } else {
                //     this.handleActionCommand('search');
                // }
            },
            handleActionCommand(command) {
                if (this.$route.name === command && this.$route.name !== 'home') return;

                switch (command) {
                    case 'home':
                        if (this.$route.name !== 'home') {
                            let lastSearch = JSON.parse(window.sessionStorage.getItem('lastSearchProfile') || '{}');
                            // this.$router.push('/');
                            if (!lastSearch) {
                                window.localStorage.setItem('wordStatQuery', JSON.stringify({
                                    query: this.filterQuery,
                                    docType: 'Science',
                                    isNativeQuery: this.isNativeQuery,
                                }));
                            }
                            window.location = document.location.origin + this.$store.state.contextUrl + '/#/';
                        } else {
                            window.sessionStorage.removeItem('lastSearchProfile');
                            window.sessionStorage.removeItem('globalParams');
                            window.localStorage.removeItem('wordStatQuery');
                            window.location = window.location.href.replace('#/', '');
                        }
                        break;

                    case 'search':
                        window.location = document.location.origin + this.$store.state.contextUrl + '/#/';
                        break;
                    case 'smartSearch':
                        // this.$emit('saveLastFilter');
                        this.$router.push('/smartSearch');
                        break;
                    case 'langEn':
                        this.changeLocale('en');
                        break;
                    case 'langRu':
                        this.changeLocale('ru');
                        break;
                    case 'admin':
                        this.$emit('saveLastFilter');
                        this.$router.push('/admin');
                        break;
                    case 'settings':
                        this.$emit('saveLastFilter');
                        this.$router.push('/settings');
                        break;
                    case 'clusterMap':
                        this.$emit('saveLastFilter');
                        this.$router.push('/clusterMap');
                        break;
                    case 'compare':
                        this.$emit('saveLastFilter');
                        this.$router.push('/compare');
                        break;
                    case 'clusters':
                        this.$emit('saveLastFilter');
                        this.$router.push('/clusters');
                        break;
                    case 'iqAgent':
                        this.$emit('saveLastFilter');
                        this.$router.push('/iqAgent');
                        break;
                    case 'dashboard':
                        this.$emit('saveLastFilter');
                        this.$router.push('/dashboard');
                        break;
                    case 'searchProfile':
                        this.$emit('saveLastFilter');
                        this.$router.push('/searchProfile');
                        break;
                    case 'logout':
                        window.sessionStorage.removeItem('lastSearchProfile');
                        window.sessionStorage.removeItem('globalParams');
                        window.location.href = this.$store.state.contextUrl + '/logout';
                        break;
                }
            },
            handleShowDataCoverage() {
                this.$modal.dialog(DataCoverage, {
                    title: this.$t('label.dataCoverage'),
                    params: {
                        style: 'background: #fff;'
                    },
                    size: 'lg',
                    buttons: [{
                        name: 'Ok',
                        type: 'text',
                        handler: data => {
                            data.dialog.close();
                        }
                    }]
                }).catch(() => {
                });

            },
            handleDataReport(type) {
                let self = this;
                self.dataReport = {
                    title: self.$t('dataReport.' + type + '.title'),
                    type: type
                };
                self.$refs.dataReport.showReport(true);
            },
            showUserFeedback(type) {
                this.$refs.feedbackForm.show = true;
                this.$refs.feedbackForm.type = type;
            },
            changeLocale(locale) {
                i18n.locale = this.locale = locale;
                this.$emit('changeLang');
                this.$store.commit('locale', locale);
                this.$services.userSettings.save({locale: locale}).then(resp => {
                    // console.log('userSettings: ', resp.data);
                    // window.location = window.location.href.replace(/\#.*/g, '');
                });

            },
            handleTourStep(step) {
                this.$emit('tourStep', step);
                if (!step) {
                    this.resetTour();
                }
            },
            handleNextStep(step = '') {
                let self = this,
                    _timer;
                if (step === 'skip') {
                    self.handleTourStep(null);
                } else {
                    let rez = self.$utils.tourNextStep({
                        step: step,
                        tour: self.tour
                    });
                    if (rez === 'nextTourBlock') {
                        self.handleTourStep('2');
                    } else if (rez === 'previousTourBlock') {
                        self.handleTourStep('0');
                    }
                }
            },
            resetTour() {
                let _tour = this.tour;
                _tour.curStep.index = 0;
                _tour.curStep.title = _tour.steps[0].title;
                _tour.curStep.text = _tour.steps[0].text;
                _.forEach(_tour.highlight, (it, i) => {
                    _tour.highlight[i] = false;
                });
            },
            handleChangeLocale(lang) {
                i18n.locale = lang;
            },
            handleQueryFieldChange(item) {
                console.log(item);
                let self = this,
                    _qF = {
                        standard: [],
                        title: ['title'],
                        titleDescription: ['title', 'description', 'systemKeywords'],
                        companies: ['companies']
                    };
                this.$emit('queryFieldsChange', _qF[item]);
            },
            handleExport() {
                let fileName = 'TrendMonitoring_' + moment().format('YYYY-MM-DD_HH-mm') + '.xlsx';
                this.exportLoading = true;

                axios({
                    url: this.$store.state.apiUrl + '/analytics/trendMonitoringExport',
                    method: 'POST',
                    data: null,
                    responseType: 'blob',
                    headers: {'Content-Type': 'application/json;charset=UTF-8'}
                }).then((resp) => {
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(resp.data);
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    setTimeout(() => {
                        this.exportLoading = false;
                    }, 277)
                })
            },

        }
    }
</script>

<style lang="scss">
    .fst-Header {
        position: relative;
        display: flex;
        padding: 20px 0;
        background: $iq-color-white;
        box-shadow: $iq-shadow;
        z-index: 2000;

        .header-left {
            flex-basis: 350px;

            .logo {
                outline: none;
                display: flex;
                align-items: flex-start;
                height: 100%;
                padding: 5px 0 0 20px;
                position: relative;

                svg {
                    width: 175px;
                    margin-right: 15px;
                }

                img {
                    height: 36px;
                }

                &.isLink {
                    cursor: pointer;
                }

                > span {
                    margin-left: 10px;
                }
            }
        }

        .header-center {
            flex-basis: 870px;
            margin-right: 20px;
            align-items: flex-start;
            position: relative;
        }

        .header-right {
            flex: 1;
            text-align: right;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            padding: 5px 20px 0 0;


            .select-block {
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                justify-content: flex-end;
                gap: 1px 10px
            }

            .user {
                display: inline-flex;
                //padding: 0 0 0 20px;
                white-space: nowrap;

                .el-dropdown, .el-select {
                    color: $iq-color-grey-light;
                }

                .el-dropdown-link {
                    cursor: pointer;
                    display: inline-block;
                    padding: 3px 15px 3px 0;
                }

                .el-avatar {
                    margin-right: 10px;
                    background: $iq-color-blue-light;
                }

                .user-name {
                    font-size: 15px;
                    font-weight: bold;
                    margin-right: 10px;
                }
            }

            .help-block {
                border-left: 1px solid $iq-color-blue-medium;
                padding-left: 15px;
                display: flex;
                gap: 15px;
            }

        }

        .help-btn {
            cursor: pointer;
            color: $iq-color-blue-medium;
            font-size: 20px;
            padding: 3px 0;
            background: none;
            border: none;

            & + .help-btn {
                margin-left: 15px;
            }

            &:hover {
                background: none;
            }
        }

        .el-select {
            display: flex;
            align-items: center;

            .el-input--small .el-input__inner {
                border: none;
                outline: none;
                background: transparent;
                font-size: 15px;
                font-weight: 700;
                color: $iq-color-grey-light;
                line-height: 1;
            }

            .el-input .el-select__caret {
                font-weight: 900;
                color: $iq-color-grey-light;
            }

            &.changeLocale {
                width: 75px;
                margin-right: 4px;
            }

        }

        .appMode {
            margin: 5px 10px 0 0;

            select, .el-input--small .el-input__inner {
                font-size: 12px;
                padding: 2px 22px 2px 2px; // 15px caret + 7px gap
                font-family: 'Aqum', 'Robot', sans-serif;
                color: $iq-color-blue;
            }

            &.el-select .el-input .el-select__caret {
                color: $iq-color-blue;
            }

            input[type="text"] {
                width: 92px;
            }

            &.locale-en {
                input[type="text"] {
                    width: 97px;
                }
            }
        }

        &.showStructuredQuery {
            .header-left .logo {
                margin-top: -2px;
                padding-top: 0;
            }

            .header-right {
                padding-top: 0;
            }
        }

        .experimentalBtn {
            text-align: left;
            position: relative;
            display: flex;

            .el-menu--horizontal.el-menu {
                border: none;

                > .el-submenu {
                    .el-submenu__title {
                        height: auto;
                        line-height: 1;
                    }

                    &.is-active .el-submenu__title {
                        border: none;
                    }

                    &:after {
                        display: none;
                    }
                }
            }

            .el-submenu__title {
                padding: 0;
                height: auto;
                line-height: 1;

                i {
                    color: $iq-color-blue;
                }

            }

            .el-submenu__icon-arrow.el-icon-arrow-down {
                display: none;
            }

            .button {
                background: $iq-color-blue-light;
                display: inline-flex;
                width: 50px;
                height: 50px;
                justify-content: center;
                align-items: center;
                box-sizing: border-box;
                border: none;
                border-radius: 5px;
                cursor: pointer;
                outline: none;
                color: $iq-color-blue;
                font-size: 20px;
                line-height: 1;
                transition: all .5s ease;
                margin-left: 10px;
                position: relative;

                &:hover {
                    background: $iq-color-blue-medium;
                }

                .icon-check {
                    display: none;
                }

                &.active, &.saving {
                    background: $iq-color-blue;
                    color: $iq-color-white;
                }

                &.saving {
                    .icon-check {
                        display: inline-block;
                    }

                    .icon-save {
                        display: none;
                    }
                }
            }
        }


    }


    @media only screen and (max-width: 1450px) {
        #app {
            .fst-Header {
                .header-right {
                    .select-block {
                        align-items: baseline;

                        .el-select.changeLocale {
                            margin-right: 4px;
                        }

                        .el-input--small .el-input__inner {
                            height: 28px;
                        }
                    }

                    .help-block {
                        padding-left: 7px;
                    }
                }

                .header-left {
                    flex-basis: 200px !important;
                    flex-shrink: 0;
                    margin-right: 0;
                    overflow: hidden;

                    .logo {
                        svg {
                            [data-name="logo-text"] {
                                display: none;
                            }
                        }
                    }
                }

                .appMode {
                    margin-right: 10px;
                    margin-left: -80px;
                    position: absolute;
                    left: 150px;
                }
            }
        }
    }
</style>
<style scoped lang="scss">
    .queryFieldsControl {
        .title {
            font-weight: 500;
            font-size: 15px;
        }

        .el-radio-group {
            label {
                display: block;
                margin: 10px 0;
            }
        }
    }

    .el-dropdown-menu {
        .is-disabled {
            b.title {
                opacity: .75;
                font-size: 14px;
            }
        }
    }

</style>